module.exports = __webpack_public_path__ + "img/404.2ff881a5.jpg";